import { createFileRoute } from "@tanstack/react-router";
import { routeMeta } from "@/lib/route-meta";
import TermsOfUse from "@/pages/TermsOfUse";

export const Route = createFileRoute("/terms-of-use")({ head: () => routeMeta('Terms of Use | MNRE', 'Read the terms that apply when using the MNRE website and services.', '/terms-of-use'), component: TermsOfUse });
